import { FREQUENCY_LABEL, type PayFrequency, type SalaryView } from '@/client/types/hr';

export function money(amount: number, currency: string) {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency, maximumFractionDigits: 2 }).format(amount);
  } catch {
    return `${currency} ${amount.toLocaleString()}`;
  }
}

export function pay(amount: number, currency: string, frequency: PayFrequency) {
  return `${money(amount, currency)} ${FREQUENCY_LABEL[frequency]}`;
}

export function salary(s: SalaryView | null | undefined) {
  return s ? pay(s.amount, s.currency, s.frequency) : '—';
}

/** Sum amounts per currency, e.g. "GHS 12,000 · USD 400". Never converts. */
export function totals(items: { amount: number; currency: string }[]) {
  const by = new Map<string, number>();
  items.forEach((i) => by.set(i.currency, (by.get(i.currency) ?? 0) + i.amount));
  return [...by.entries()].map(([c, a]) => money(a, c)).join(' · ') || '—';
}
